import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { provideStates } from '@ngxs/store';
import { NotFoundComponent, UnauthorizedComponent } from '@tran-monorepo/frontend/components';
import { KpisState, LocationState, OrgUnitState, SubjectAreasState, UnitsState } from '@tran-monorepo/frontend/states';
import { AboutComponent } from './pages/about/about.component';
import { ApplicationDetailComponent } from './pages/application-detail/application-detail.component';
import { CustomerApplicationDetailState } from './pages/application-detail/state/application-detail/application-detail.state';
import { ApplicationFormState } from './pages/application-form/states/application-form/application-form.state';
import { ApplicationSubmittedComponent } from './pages/application-submitted/application-submitted';
import { ApplicationsOverviewComponent } from './pages/applications-overview/applications-overview.component';
import { CustomerApplicationsOverviewState } from './pages/applications-overview/state/applications-overview/applications-overview.state';
import { FaqComponent } from './pages/faq/faq.component';
import { HomeComponent } from './pages/home/home.component';
import { AwardCommitteeMeetingsState } from './pages/home/states/award-committee-meetings/award-committee-meetings.state';
import { ApplicationAttachmentsState } from './shared/states/application-attachments/application-attachments.state';

export const appRoutes: Routes = [
    {
        path: '',
        data: { title: 'page-titles.home' },
        component: HomeComponent,
        providers: [provideStates([AwardCommitteeMeetingsState])],
        canActivate: [MsalGuard]
    },
    {
        path: 'about',
        component: AboutComponent,
        canActivate: [MsalGuard]
    },
    {
        path: 'apply',
        data: { title: 'page-titles.new-application' },
        canActivate: [MsalGuard],
        providers: [
            provideStates([
                LocationState,
                OrgUnitState,
                KpisState,
                UnitsState,
                SubjectAreasState,
                ApplicationFormState,
                ApplicationAttachmentsState
            ])
        ],
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('./pages/application-form/application-form.component').then(m => m.ApplicationFormComponent)
            },
            {
                path: ':applicationId',
                loadComponent: () =>
                    import('./pages/application-form/application-form.component').then(m => m.ApplicationFormComponent)
            }
        ]
    },
    { path: 'submitted', component: ApplicationSubmittedComponent, canActivate: [MsalGuard] },
    {
        path: 'applications',
        data: { title: 'page-titles.my-applications' },
        component: ApplicationsOverviewComponent,
        canActivate: [MsalGuard],
        providers: [provideStates([CustomerApplicationsOverviewState])]
    },
    {
        path: 'faq',
        data: { title: 'page-titles.faq' },
        component: FaqComponent,
        canActivate: [MsalGuard]
    },
    {
        path: 'application/:applicationId',
        data: { readonly: true, title: 'page-titles.detail-application-view' },
        component: ApplicationDetailComponent,
        canActivate: [MsalGuard],
        providers: [provideStates([CustomerApplicationDetailState, ApplicationAttachmentsState])]
    },
    {
        path: 'not-found',
        data: { title: 'page-titles.not-found' },
        component: NotFoundComponent
    },
    {
        path: 'unauthorized',
        data: { title: 'page-titles.unauthorized', management: false },
        component: UnauthorizedComponent
    },
    {
        path: '**',
        redirectTo: 'not-found',
        pathMatch: 'full'
    }
];
